import { render, staticRenderFns } from "./OptimizationAutomationPage.vue?vue&type=template&id=7384a160&"
import script from "./OptimizationAutomationPage.vue?vue&type=script&lang=js&"
export * from "./OptimizationAutomationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports